import { render, staticRenderFns } from "./LoadComponent.vue?vue&type=template&id=fad9bb48"
import script from "./LoadComponent.vue?vue&type=script&lang=js"
export * from "./LoadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports